import { Helmet } from 'react-helmet';
import { Text } from '@chakra-ui/react';
import { useDispatch, useSelector } from 'react-redux';
import SectionStartTemplate from '../../../templates/sectionStart';
import { titleAppend } from '../../../../utilities/head';
import {
  createNavigateForwardAction,
  createNavigateToAction,
  createNavigateBackwardAction
} from '../../../../middleware/actions';
import { ApplicationState } from '../../../../store';
import { toggleTaskMenu } from '../../../../store/ui/actions';

const InterviewSectionStart = () => {
  const dispatch = useDispatch();

  const pageTitle = useSelector((state: ApplicationState) => state.config.Interview.SectionStart.title);

  const onNext = () => {
    dispatch(createNavigateForwardAction());
  };
  const onPrevious = () => {
    dispatch(createNavigateBackwardAction());
  };
  const onBackToTaskList = () => {
    dispatch(createNavigateToAction('/dashboard'));
    dispatch(toggleTaskMenu(false));
  };

  return (
    <SectionStartTemplate
      pageHeader={pageTitle}
      minsToComplete={15}
      hideProgress={true}
      onNext={onNext}
      onPrevious={onPrevious}
      onBackToTaskList={onBackToTaskList}
    >
      <Helmet>
        <title>
          {pageTitle}: Introduction {titleAppend}
        </title>
      </Helmet>

      <Text fontSize="lg">Answer a few questions about your upcoming overseas study</Text>
    </SectionStartTemplate>
  );
};

export default InterviewSectionStart;
